// ===============================
// SOLUTIONS D'AUDIT FINANCIER - DONNÉES
// ===============================

// 1️⃣ Audit des États Financiers
export const financialStatementAuditHeading = {
  subtitle: "NOS SERVICES",
  title: "SUPPORT D'AUDIT COMPLET QUI BÂTIT LA CONFIANCE",
  description:
    "Nous aidons les organisations à présenter des états fiables et propres qui résistent à l'examen des régulateurs, des prêteurs et des investisseurs.",
};

export const financialStatementAuditData = [
  {
    title: "Revue de l'Exactitude Financière",
    text: "Nous validons chaque état clé et registre sous-jacent pour garantir que vos données financières sont exemptes d'erreurs, cohérentes et prêtes pour l'audit.",
  },
  {
    title: "Évaluation des Contrôles Internes",
    text: "Nous identifions les lacunes de contrôle dans les processus et systèmes, vous aidant à renforcer l'atténuation des risques et la fiabilité opérationnelle.",
  },
  {
    title: "Vérification de la Conformité & des Normes",
    text: "Nous examinons vos pratiques par rapport aux IFRS, aux PCGR et aux réglementations locales pour garantir une conformité totale et éviter les pénalités de reporting.",
  },
  {
    title: "Reporting d'Analyses et d'Insights",
    text: "Nous transformons les données financières en insights et tendances clairs qui soutiennent des décisions de conseil d'administration plus intelligentes et une meilleure gouvernance.",
  },
];

// 2️⃣ Service Conseil IFRS
export const ifrsAdvisoryServiceHeading = {
  subtitle: "NOTRE EXPERTISE",
  title: "SOLUTIONS CONSEILS IFRS COMPLÈTES",
  description:
    "Notre support IFRS facilite les évaluations comptables complexes, avec une mise en œuvre complète de feuilles de route pour un reporting financier précis, transparent et prêt pour l'audit.",
};

export const ifrsAdvisoryServiceData = [
  {
    title: "Mise en Œuvre des IFRS",
    text: "Assistance à l'adoption de normes IFRS nouvelles ou révisées, y compris analyse des écarts, alignement du reporting et support à la transition.",
  },
  {
    title: "Problèmes Comptables Complexes",
    text: "Conseils sur la reconnaissance des revenus, les contrats de location, les instruments financiers, la consolidation et l'évaluation à la juste valeur.",
  },
  {
    title: "Revue des États Financiers",
    text: "Revue et amélioration des divulgations IFRS pour renforcer la clarté, l'exactitude et la conformité réglementaire.",
  },
  {
    title: "Formation & Développement des Compétences",
    text: "Ateliers IFRS sur mesure conçus pour améliorer les compétences des équipes financières, renforcer la qualité du reporting et développer des capacités à long terme.",
  },
];

// 3️⃣ Autres Services d'Assurance
export const otherAssuranceServiceHeading = {
  subtitle: "NOS SERVICES",
  title: "ASSURANCE INDÉPENDANTE POUR LES DOMAINES CRITIQUES DE L'ENTREPRISE",
  description:
    "Nos services d'assurance apportent des preuves indépendantes, afin que ce que vous rapportez soit digne de confiance, défendable et prêt à influencer les investisseurs, les régulateurs et les partenaires.",
};

export const otherAssuranceServiceData = [
  {
    title: "Robustesse du Contrôle",
    text: "Nous testons l'efficacité réelle de vos systèmes ; pas sur le papier, mais dans les flux de travail réels, sous pression réelle, avec une exposition réelle aux risques.",
  },
  {
    title: "Crédibilité de la Conformité",
    text: "Nous vérifions les interprétations de conformité, les traces documentaires et les pratiques de reporting pour que vous puissiez faire face aux examens avec des preuves.",
  },
  {
    title: "Preuve de Durabilité (ESG)",
    text: "Nous validons les déclarations ESG, les affirmations de performance et les données d'émissions afin que la communication sur la durabilité résiste aux contestations des investisseurs.",
  },
  {
    title: "Intégrité du Reporting",
    text: "Nous examinons les KPI, les indicateurs opérationnels et les rapports de direction pour garantir que chaque chiffre présenté est exact et reproductible.",
  },
];

// 4️⃣ Cadre de Contrôle Interne
export const internalControlFrameworkHeading = {
  subtitle: "RENFORCEMENT DU CONTRÔLE INTERNE",
  title: "CADRES CONÇUS POUR DÉTECTER & PRÉVENIR",
  description:
    "Nous ne faisons pas qu'évaluer les contrôles ; nous les reconstruisons en systèmes qui résistent sous pression et évoluent avec la croissance.",
};

export const internalControlFrameworkData = [
  {
    title: "Cartographie des Contrôles",
    text: "Nous décodons comment le travail circule réellement dans votre organisation et construisons un plan visuel qui met en lumière les inefficacités cachées.",
  },
  {
    title: "Diagnostic des Écarts",
    text: "Nos experts identifient les points de contact vulnérables, les dépendances manuelles, les conflits de séparation des tâches et les zones propices à la fraude.",
  },
  {
    title: "Conception de Contrôles",
    text: "Au lieu de listes de contrôle génériques, nous créons des contrôles adaptés à vos flux de travail, à votre modèle d'entreprise et à votre maturité technologique.",
  },
  {
    title: "Intégration du Cadre",
    text: "Nous vous aidons à aller au-delà de la documentation vers une adoption réelle et à mettre en place des boucles de rétroaction pour que les contrôles évoluent avec la croissance, les mises à niveau ERP ou les changements du marché.",
  },
];

export const dealAdvisoryHeading = {
  subtitle: "SUPPORT STRATÉGIQUE AUX TRANSACTIONS",
  title: "ACCOMPAGNEMENT DE BOUT EN BOUT SUR LE CYCLE DE VIE DES TRANSACTIONS",
  description:
    "Nous assistons tout au long des transactions côté acheteur et côté vendeur — de l'identification des opportunités à la clôture de transactions créatrices de valeur.",
};

export const dealAdvisoryData = [
  {
    title: "Conseil en Fusions & Acquisitions",
    text: "Ciblage, modélisation des synergies & stratégie de transaction pour une intégration fluide et un gain à long terme maximal.",
  },
  {
    title: "Évaluation d'Entreprise",
    text: "Évaluations de la juste valeur basées sur les données financières, les conditions du marché, le potentiel de croissance et les attentes des parties prenantes.",
  },
  {
    title: "Due Diligence",
    text: "Due diligence financière, commerciale et opérationnelle pour valider les hypothèses, révéler les risques cachés et permettre une prise de décision éclairée.",
  },
  {
    title: "Support à la Cession",
    text: "Planification de sortie, identification des acheteurs & optimisation du capital pour garantir une vente au bon moment et à la bonne valeur.",
  },
];
export const restructuringHeading = {
  subtitle: "NOS OFFRES DE RESTRUCTURATION",
  title: "SOLUTIONS CONÇUES POUR LA RELANCE",
  description:
    "Notre soutien à la restructuration réduit les déficits de trésorerie, débloque le fonds de roulement, restaure la confiance des prêteurs et place l'organisation sur la voie d'une stabilité rentable.",
};

export const restructuringData = [
  {
    title: "Réalignement de la Dette",
    text: "Nous restructurons les conditions de prêt, redéfinissons le remboursement, améliorons la qualité de l'emprunt et reconstruisons la confiance des prêteurs pour que votre entreprise puisse à nouveau respirer.",
  },
  {
    title: "Redéfinition de la Structure des Coûts",
    text: "Pas de réduction des coûts, mais de l'ingénierie des coûts. Nous éliminons les inefficacités, améliorons la productivité des ressources et remodelons les frais généraux pour les entreprises.",
  },
  {
    title: "Correction du Fonds de Roulement",
    text: "Nous libérons les liquidités bloquées dans les opérations — rotation plus rapide des stocks, conditions fournisseurs plus intelligentes et contrôle de trésorerie qui maintient la liquidité.",
  },
  {
    title: "Stratégie de Redressement",
    text: "Une nouvelle vision du marché, une discipline de prix renouvelée, des portefeuilles réalignés et un modèle d'avancement pour une dynamique de croissance stratégique.",
  },
];
export const dueDiligenceHeading = {
  subtitle: "CE À QUOI VOUS POUVEZ VOUS ATTENDRE",
  title: "UNE INTELLIGENCE DE TRANSACTION QUI TRAVAILLE POUR VOUS",
  description:
    "Nous aidons les acheteurs, les investisseurs, les prêteurs et les acquéreurs à prendre des décisions étayées par des preuves — et non par de l'optimisme.",
};

export const dueDiligenceData = [
  {
    title: "Revue de l'Intégrité Financière",
    text: "Nous vérifions les performances déclarées, normalisons les bénéfices, évaluons la santé du fonds de roulement et identifions les écarts de qualité des revenus cachés derrière les chiffres de croissance.",
  },
  {
    title: "Vérification de la Réalité Opérationnelle",
    text: "Nous étudions la résilience de la chaîne d'approvisionnement, l'évolutivité, les processus et la capacité d'exécution — pas seulement ce que prétendent les présentations.",
  },
  {
    title: "Examen de la Position sur le Marché",
    text: "Nous évaluons la position concurrentielle, la fidélité des clients, le pouvoir de fixation des prix, le risque de désabonnement et les perspectives de croissance réelles - sur la base des fondamentaux du marché.",
  },
  {
    title: "Cartographie des Risques & des Expositions",
    text: "Nous dévoilons les vulnérabilités en matière de conformité, de fiscalité, de contrats, de litiges et d'exposition ESG — garantissant qu'aucune responsabilité cachée n'apparaisse plus tard.",
  },
];
export const forensicServicesHeading = {
  subtitle: "NOS CAPACITÉS FORENSIQUES",
  title: "ENQUÊTE, INSIGHT & PREUVES ADMISSIBLES EN JUSTICE",
  description:
    "Solutions forensiques sur mesure pour déceler la fraude, soutenir les litiges, résoudre les différends et préserver la crédibilité de l'entreprise.",
};

export const forensicServicesData = [
  {
    title: "Examen de la Fraude & du Détournement",
    text: "Trace la diversion de fonds, les fournisseurs fictifs, les dépenses gonflées, la collusion interne et l'utilisation abusive d'actifs avec des pistes d'audit structurées.",
  },
  {
    title: "Support aux Litiges & Différends",
    text: "Rapports fondés sur des preuves, déclarations de pertes quantifiées et documentation probante recevable devant les tribunaux, l'arbitrage ou l'examen des régulateurs.",
  },
  {
    title: "Forensique Numérique & Cyber",
    text: "Extraction de journaux, traçabilité des emails, cartographie des pistes d'accès et récupération de preuves numériques pour les malversations financières facilitées par le cyberespace.",
  },
  {
    title: "Conseil en Recouvrement Post-Fraude",
    text: "Assistance pour la stratégie de recouvrement, le support au règlement et le renforcement des contrôles pour prévenir la récidive.",
  },
];
export const riskAdvisoryHeading = {
  subtitle: "NOS SOLUTIONS",
  title: "PRÉVENTION DES RISQUES & CONFIANCE DANS LE REDRESSEMENT",
  description:
    "Nous concevons des cadres qui ne se contentent pas de réagir aux risques — ils les anticipent et les éliminent tôt.",
};

export const riskAdvisoryData = [
  {
    title: "Gestion des Risques d'Entreprise",
    text: "Construction de matrices de gouvernance des risques, de voies de reporting, d'indicateurs clés de risque (ICR) et de protocoles d'escalade pour une résilience à l'échelle de l'organisation.",
  },
  {
    title: "Risque Réglementaire & de Conformité",
    text: "Analyse des écarts, cartographie de la conformité, revue des contrôles et préparation aux normes réglementaires locales et internationales.",
  },
  {
    title: "Risque Opérationnel & de Processus",
    text: "Identification des défaillances de processus, des faiblesses du contrôle interne, de l'exposition à la fraude et des vulnérabilités de continuité.",
  },
  {
    title: "Planification de la Continuité d'Activité",
    text: "Structures de réponse aux crises, cadres de reprise, protocoles de communication et simulation de scénarios pour une préparation aux perturbations.",
  },
];
export const technologyAdvisoryHeading = {
  subtitle: "CE QUE NOUS LIVRONS",
  title: "SOLUTIONS TECHNIQUES QUI RÉSOLVENT DES PROBLÈMES",
  description:
    "La technologie n'a d'importance que lorsqu'elle améliore la productivité ou réduit les coûts. Nous aidons les organisations à adopter des capacités numériques qui font réellement bouger les chiffres.",
};

export const technologyAdvisoryData = [
  {
    title: "Stratégie Technologique & Feuilles de Route",
    text: "Nous interprétons les objectifs commerciaux en plans technologiques réalistes, évolutifs et dignes d'investissement — pas en PDF théoriques.",
  },
  {
    title: "Sélection & Mise en Œuvre d'ERP",
    text: "Nous évaluons les fournisseurs, négocions la valeur, construisons des chemins d'adoption et veillons à ce que l'ERP devienne un facilitateur de croissance — et non un échec coûteux.",
  },
  {
    title: "Modernisation Cloud & Infrastructure",
    text: "Nous transférons les systèmes hérités vers le cloud en priorisant la sécurité, la stabilité de la disponibilité et le contrôle des coûts — pas seulement la migration par effet de mode.",
  },
  {
    title: "Intelligence des Données & Automatisation",
    text: "Nous transformons les données éparses en insights, automatisons les tâches répétitives et aidons les équipes à prendre des décisions plus rapides avec des flux de travail assistés par l'IA.",
  },
];
export const valuationsHeading = {
  subtitle: "NOS SOLUTIONS D'ÉVALUATION",
  title: "DES ÉVALUATIONS QUI ONT DU POIDS",
  description:
    "Des évaluations construites pour guider les salles de conseil, pas seulement pour remplir des rapports. Chaque évaluation est structurée, comparée et testée pour l'avenir.",
};

export const valuationsData = [
  {
    title: "Évaluation d'Entreprise",
    text: "Clarté sur la valeur d'entreprise pour les fusions, les ventes de participation, les investissements en capital-investissement/ capital-risque et les actions de restructuration.",
  },
  {
    title: "Évaluation d'Actifs & de Titres",
    text: "Évaluation indépendante des actifs corporels, de la propriété intellectuelle incorporelle, des capitaux propres, de la dette et des instruments hybrides.",
  },
  {
    title: "Évaluation de Startup & de Jeunes Entreprises",
    text: "Évaluation prospective basée sur la modélisation de la croissance, l'attrait du marché, l'économie unitaire et l'évolutivité.",
  },
  {
    title: "Équité & Répartition du Prix d'Acquisition",
    text: "Soutien approfondi à l'évaluation lors des acquisitions garantissant que les prix de transaction reflètent la vraie valeur — et non des attentes gonflées.",
  },
];

// FISCALITÉ DES ENTREPRISES
export const corporateTaxHeading = {
  subtitle: "SOLUTIONS DE FISCALITÉ DES ENTREPRISES",
  title: "DES CONSEILS QUI ÉQUILIBRENT ÉCONOMIES & CONFORMITÉ",
  description:
    "Nous soutenons les entreprises tout au long du cycle fiscal — de la planification, la déclaration et les vérifications à la structuration à long terme.",
};

export const corporateTaxData = [
  {
    title: "Stratégie & Structuration Fiscale",
    text: "Nous concevons des structures d'entreprise fiscalement efficaces, évaluons les canaux de profit et identifions les opportunités déductibles.",
  },
  {
    title: "Gestion des Déclarations, Dépôts & Conformité",
    text: "Déclarations d'entreprise, divulgations, vérifications de conformité et gestion documentaire de bout en bout — réduisant les erreurs de dépôt.",
  },
  {
    title: "Vérifications, Enquêtes & Défense",
    text: "Support complet de représentation lors des notifications, audits ou différends — avec une préparation documentaire pour une résolution plus rapide.",
  },
  {
    title: "Structures de Groupe & Modèles Fiscaux d'Expansion",
    text: "Conseils pour les fusions, acquisitions et expansions transfrontalières afin d'optimiser la charge fiscale et l'exposition des années futures.",
  },
];

// FUSIONS & ACQUISITIONS
export const mergerAndAcquisitionHeading = {
  subtitle: "CONÇU POUR DE MEILLEURES TRANSACTIONS",
  title: "SUPPORT FISCAL SUR TOUT LE CYCLE DE VIE DES F&A",
  description:
    "Chaque transaction a des conséquences fiscales — certaines font économiser de l'argent, d'autres le brûlent. Nous veillons à ce que la structure de votre transaction soit optimisée fiscalement et conçue pour protéger la valeur à long terme.",
};

export const mergerAndAcquisitionData = [
  {
    title: "Structuration de Transaction Optimisée",
    text: "Nous structurons les fusions, acquisitions pour minimiser les fuites, débloquer les déductions et améliorer le ROI.",
  },
  {
    title: "Intelligence des Risques Intelligente",
    text: "Due diligence approfondie pour révéler les passifs cachés, les expositions fiscales, les écarts de prix de transfert et les angles morts de conformité.",
  },
  {
    title: "Intégration Transfrontalière",
    text: "Planification fiscale pour les entités mondiales, les routes de rapatriement, les montages de sociétés holding et le positionnement pour bénéficier des conventions.",
  },
  {
    title: "Alignement Post-Fusion Transparent",
    text: "Support pratique à l'intégration, alignement des livres fiscaux, report des avantages et consolidation des entités.",
  },
];

// PRIX DE TRANSFERT
export const transferPricingHeading = {
  subtitle: "CAPACITÉS EN PRIX DE TRANSFERT",
  title: "CONSEIL DE BOUT EN BOUT SUR LA POLITIQUE & LA PREUVE",
  description:
    "Chaque modèle de prix de transfert doit être fondé sur des données, et nos solutions couvrent la gouvernance, la conformité et la documentation.",
};

export const transferPricingData = [
  {
    title: "Étude de Prix de Transfert",
    text: "Nous analysons les fonctions, les actifs, les risques et les réalités économiques pour construire une tarification qui résiste à l'examen.",
  },
  {
    title: "Conventions Interentreprises",
    text: "Une logique de frais claire, une distribution des risques et une contribution à la valeur garantissent que les autorités fiscales reconnaissent le droit économique de chaque entité.",
  },
  {
    title: "Documentation Fichier Local + Fichier Maître",
    text: "Une documentation qui raconte votre chaîne de valeur et vous prépare aux audits dans plusieurs juridictions en toute confiance.",
  },
  {
    title: "Règlement des Différends",
    text: "Lorsque les autorités contestent vos chiffres, nous fournissons un support de négociation et des preuves économiques prêtes pour les litiges.",
  },
];

// TAXE SUR LA VALEUR AJOUTÉE
export const valueAddedTaxHeading = {
  subtitle: "SOLUTIONS TVA",
  title: "CONFORMITÉ, STRATÉGIE & GESTION CONTINUE",
  description:
    "Nous couvrons chaque point de contact TVA — mise en place, déclarations, interprétation, audits, documentation et structuration des transactions.",
};

export const valueAddedTaxData = [
  {
    title: "Enregistrement & Structuration TVA",
    text: "Nous évaluons les opérations, les seuils applicables et les implications des fournitures mixtes pour définir le bon chemin d'enregistrement.",
  },
  {
    title: "Dépôt des Déclarations & Gestion des Archives",
    text: "Déclarations périodiques, vérifications de conformité des factures, demandes de crédit et contrôles documentaires pour éviter les pénalités.",
  },
  {
    title: "Conseil TVA sur les Transactions",
    text: "Nous conseillons sur les fournitures transfrontalières, les règles de lieu de fourniture, l'éligibilité au taux zéro et l'impact de l'autoliquidation.",
  },
  {
    title: "Support aux Audits TVA",
    text: "Nous préparons des dossiers de défense, traitons les demandes des autorités, soutenons les clarifications et négocions si nécessaire avec des preuves à l'appui.",
  },
];

// FISCALITÉ INTERNATIONALE
export const internationalTaxHeading = {
  subtitle: "SUPPORT FISCAL DE BOUT EN BOUT",
  title: "SOLUTIONS DE FISCALITÉ INTERNATIONALE POUR L'ÉVOLUTIVITÉ",
  description:
    "La croissance transfrontalière exige plus qu'une expansion — elle nécessite une anticipation fiscale et une précision structurelle. Et nous livrons !",
};

export const internationalTaxData = [
  {
    title: "Structuration Fiscale Transfrontalière",
    text: "La planification des entités du groupe, les flux interentreprises et les schémas de holding mondiaux sont modélisés pour une efficacité des coûts à long terme.",
  },
  {
    title: "Optimisation des Conventions & Traités",
    text: "Nous évaluons l'éligibilité aux crédits d'impôt pour minimiser les fuites et garantir que chaque juridiction travaille en votre faveur.",
  },
  {
    title: "Planification de la Retenue à la Source & du Rapatriement",
    text: "Transférer des capitaux à travers les frontières ne doit pas drainer les rendements. C'est pourquoi nous aidons à gérer les frais et les transferts de PI avec des mécanismes conformes.",
  },
  {
    title: "Conformité Multi-Juridictions",
    text: "Nous rationalisons la conformité sur les exercices fiscaux, les pays et les régulateurs tout en intégrant les normes BEPS, OCDE, etc.",
  },
];

// RESTRUCTURATION FISCALE
export const taxRestructuringHeading = {
  subtitle: "NOS OFFRES DE RESTRUCTURATION",
  title: "SOLUTIONS FISCALEMENT EFFICACES POUR UNE CROISSANCE DURABLE",
  description:
    "Nos solutions de restructuration éliminent les fuites, renforcent la conformité et améliorent la rentabilité après impôt sans perturber les opérations principales.",
};

export const taxRestructuringData = [
  {
    title: "Restructuration d'Entité",
    text: "Nous redéfinissons l'agencement des entités, les flux interentreprises et les voies de propriété pour réduire les frictions fiscales et améliorer le revenu net conservable.",
  },
  {
    title: "Optimisation des Dividendes",
    text: "Routage fiscalement efficace des dividendes, déductions d'intérêts, analyse capitaux propres vs. dette — aligné pour réduire l'impact fiscal des versements.",
  },
  {
    title: "Stratégies de Reclassification",
    text: "Nous restructurons les actifs, les secteurs d'activité et les fonctions pour minimiser l'exposition sans risque de conformité.",
  },
  {
    title: "Conformité Post-Restructuration",
    text: "Les nouvelles structures sont surveillées en continu — les dépôts, la documentation et les positions fiscales restent étanches tout au long de la mise en œuvre.",
  },
];

// RÈGLEMENTS SUR LA SUBSTANCE ÉCONOMIQUE
export const economicSubstanceRegulationsHeading = {
  subtitle: "RENDRE LA SUBSTANCE AUDITABLE",
  title: "SOLUTIONS DE CONFORMITÉ ESR DE BOUT EN BOUT",
  description:
    "Nos solutions ESR minimisent les pénalités, alignent les activités sur les exigences de substance et garantissent la confiance des régulateurs.",
};

export const economicSubstanceRegulationsData = [
  {
    title: "Évaluation des Écarts",
    text: "Nous évaluons les écarts de substance sur les personnes, l'activité, la prise de décision et les dépenses pour identifier tôt les risques de dépôt.",
  },
  {
    title: "Support au Dépôt des Déclarations",
    text: "Préparation complète, soumission et examen des notifications et rapports ESR avec des narratifs faisant autorité.",
  },
  {
    title: "Renforcement du Modèle Opérationnel",
    text: "Nous aidons à la documentation des procès-verbaux du conseil, des documents CIGA et de l'allocation des ressources pour une conformité plus solide.",
  },
  {
    title: "Support à la Défense",
    text: "Représentation, dossiers de documentation et rédaction de réponses pour les audits, clarifications et évaluations de non-conformité.",
  },
];
// TAXE D'ACCISE
export const exciseTaxHeading = {
  subtitle: "NOTRE EXPERTISE FISCALE",
  title: "CADRES DE TAXE D'ACCISE CLAIRS & EXÉCUTION",
  description:
    "Nous alignons votre entreprise sur les obligations d'accise grâce à une planification structurée, une revue opérationnelle et un support continu à la conformité.",
};

export const exciseTaxData = [
  {
    title: "Enregistrement à la Taxe d'Accise",
    text: "Nous vous aidons à vous enregistrer correctement, à mettre en place des processus documentaires internes qui préviennent les litiges de responsabilité ultérieurs.",
  },
  {
    title: "Classification des Produits",
    text: "Chaque produit attire un droit différent — nous classifions avec précision et veillons à ce que les taux appliqués soient les plus bas légalement admissibles.",
  },
  {
    title: "Dépôt des Déclarations & Surveillance",
    text: "Les déclarations d'accise sont des déclarations de risque. Nous préparons, déposons et surveillons la conformité avec un objectif zéro pénalité.",
  },
  {
    title: "Représentation & Support aux Audits",
    text: "Nous défendons les vérifications, répondons aux notifications, préparons la documentation d'audit et vous représentons avec confiance devant les autorités.",
  },
];
export const financeAndAccountingHeading = {
  subtitle: "SERVICES D'ENTREPRISE INTELLIGENTS EN MATIÈRE DE TRÉSORERIE",
  title: "SUPPORT FINANCE & COMPTABILITÉ DE BOUT EN BOUT",
  description:
    "Externaliser avec Pestel & Partners signifie plus que de la tenue de livres, vous gagnez un moteur financier qui fonctionne sans accroc derrière votre entreprise.",
};
export const financeAndAccountingData = [
  {
    title: "Tenue de Livres Intelligente",
    text: "Les transactions quotidiennes toujours enregistrées avec précision. Ainsi, nous maintenons les livres financiers propres, structurés et toujours à jour.",
  },
  {
    title: "Reporting Riche en Insights",
    text: "Tableaux de bord mensuels, performance des KPI et états financiers livrés en langage commercial clair, aidant les dirigeants à voir où va l'argent.",
  },
  {
    title: "Prévisions & Modélisation de Trésorerie",
    text: "Nous construisons des cadres budgétaires, surveillons les déficits et cartographions les modèles de revenus pour vous aider à allouer les fonds intelligemment.",
  },
  {
    title: "Documentation Prête pour la Conformité",
    text: "De la clôture mensuelle à la clôture annuelle, les rapports restent prêts pour l'audit, prêts pour la fiscalité et prêts pour le conseil, afin que votre finance reste conforme.",
  },
];
export const corporateAdvisoryServicesHeading = {
  subtitle: "SUPPORT STRATÉGIQUE",
  title: "CONSEIL D'ENTREPRISE POUR DES AFFAIRES RÉELLES",
  description:
    "Nous ne nous contentons pas de recommander ; nous repensons le problème, simulons l'impact et livrons un plan d'action conçu pour un retour financier mesurable.",
};
export const corporateAdvisoryServicesData = [
  {
    title: "Structuration du Capital",
    text: "Évaluez le mix fonds propres vs. dette, optimisez l'effet de levier et réduisez les coûts du capital sans perturber la trésorerie.",
  },
  {
    title: "Stratégie d'Expansion Commerciale",
    text: "Analyse de pénétration de marché, schéma de tarification, modélisation de l'évolutivité et cadres de partenariat.",
  },
  {
    title: "Support à l'Étude de Faisabilité F&A",
    text: "Évaluation de la valeur, analyse des synergies, feuille de route d'intégration post-transaction pour sécuriser le ROI.",
  },
  {
    title: "Conseil au Conseil & Gouvernance",
    text: "Une conformité plus solide, des vérifications de reporting, une surveillance transparente et un alignement de l'exécution stratégique.",
  },
];
export const expensesClaimManagementHeading = {
  subtitle: "DÉCOMPOSITION DU SERVICE",
  title: "SYSTÈME POUR CONTRÔLER, SUIVRE & VÉRIFIER LES DÉPENSES",
  description:
    "Nous gérons chaque étape du traitement des réclamations, garantissant la transparence, la conformité aux politiques et des paiements précis.",
};
export const expensesClaimManagementData = [
  {
    title: "Soumission Intelligente des Réclamations",
    text: "Soumission numérique avec catégories prédéfinies et invites de politique pour réduire les erreurs et les données manquantes.",
  },
  {
    title: "Validation des Politiques & de la Conformité",
    text: "Chaque réclamation est vérifiée par rapport aux politiques organisationnelles, aux règles fiscales et aux normes documentaires pour prévenir les fuites financières.",
  },
  {
    title: "Traitement Rapide des Remboursements",
    text: "Flux d'approbation optimisés qui réduisent les retards de remboursement et maintiennent la satisfaction des employés.",
  },
  {
    title: "Reporting en Temps Réel",
    text: "Tableaux de bord clairs montrant les modèles de dépenses, les écarts de politique et les opportunités d'économie.",
  },
];
export const payrollHrServicesHeading = {
  subtitle: "NOS CAPACITÉS",
  title: "UN CADRE UNIFIÉ DE PAIE & RH",
  description:
    "Nos solutions de paie combinent exactitude, automatisation et conformité pour construire une fondation opérationnelle stable.",
};
export const payrollHrServicesData = [
  {
    title: "Architecture de Paie de Précision",
    text: "Un cadre de paie entièrement conçu pour éliminer l'intervention manuelle et maintenir une conformité à 100%.",
  },
  {
    title: "Dossiers du Personnel Intelligents",
    text: "Des dossiers employés numériques à la gouvernance des politiques, votre organisation acquiert un écosystème d'informations organisé et sécurisé.",
  },
  {
    title: "Gestion des Congés & Présences",
    text: "Au-delà du suivi des présences, nous fournissons des insights qui vous aident à comprendre les modèles de productivité, les lacunes en ressources et les cycles de congés.",
  },
  {
    title: "Avantages & Support aux Employés",
    text: "Une plateforme d'expérience rationalisée où les employés reçoivent de la clarté sur les bulletins de paie, les politiques, les droits, les remboursements et les avantages.",
  },
];
export const secondmentHeading = {
  subtitle: "NOS SOLUTIONS DE DÉTACHEMENT",
  title: "SUPPORT TALENT FLEXIBLE ET FIABLE",
  description:
    "Notre service de détachement va au-delà du simple remplissage de postes. Nous déployons des professionnels qui apportent des capacités immédiates, stabilisent les opérations et améliorent la performance de votre équipe.",
};
export const secondmentData = [
  {
    title: "Capacité à la Demande",
    text: "Nous fournissons des détachés pour gérer les cycles de conformité et les pics opérationnels avec précision et responsabilité.",
  },
  {
    title: "Support Spécialisé pour les Projets",
    text: "Lors des transitions ERP, nos experts offrent une profondeur technique et la capacité supplémentaire dont votre équipe centrale a besoin pour rester sur la bonne voie.",
  },
  {
    title: "Support à Long Terme de la Main-d'Œuvre",
    text: "Comblez les lacunes de compétences causées par les démissions, les congés maladie ou les phases d'expansion avec des professionnels fiables qui garantissent stabilité et cohérence.",
  },
  {
    title: "Supervision de Détachement Géré",
    text: "Nous supervisons, évaluons et soutenons nos détachés tout au long de leur engagement, garantissant une production de qualité et un professionnalisme.",
  },
];
export const treasuryServiceHeading = {
  subtitle: "NOS CAPACITÉS",
  title: "SUPPORT TRÉSORERIE CONÇU AUTOUR DE LA DISCIPLINE DE TRÉSORERIE",
  description:
    "Nous aidons les entreprises à renforcer leur liquidité, simplifier les processus de trésorerie et réduire l'exposition aux risques financiers et opérationnels grâce à un support de trésorerie structuré.",
};
export const treasuryServiceData = [
  {
    title: "Visibilité Centralisée de la Trésorerie",
    text: "Nous établissons des tableaux de bord de trésorerie transparents afin que la direction puisse suivre les entrées, sorties et positions de liquidité en temps réel.",
  },
  {
    title: "Relation Bancaire & Supervision des Transactions",
    text: "Nous gérons la communication, les mandats, les signataires et les revues de transactions pour garantir que les opérations bancaires restent conformes.",
  },
  {
    title: "Contrôles de Trésorerie & Surveillance des Risques",
    text: "Nous renforçons votre environnement de contrôle interne grâce à des flux d'approbation, une séparation des tâches et des mesures de prévention de la fraude.",
  },
  {
    title: "Gestion du Fonds de Roulement",
    text: "Nous fournissons des modèles de prévision de trésorerie à court et long terme qui aident les entreprises à planifier leurs obligations.",
  },
];
// STRATÉGIES
export const marketResearchHeading = {
  subtitle: "NOS CAPACITÉS",
  title: "DES RECHERCHES QUI AJOUTENT UNE DIRECTION",
  description:
    "Chaque insight que nous fournissons sert un objectif commercial, comme identifier des lacunes, valider des opportunités, comparer la concurrence ou façonner des stratégies de mise sur le marché.",
};

export const marketResearchData = [
  {
    title: "Paysage du Marché & de l'Industrie",
    text: "Nous interprétons les signaux faibles et les changements émergents comme le sentiment des consommateurs, les changements de politique et les perturbations de catégorie.",
  },
  {
    title: "Comportement du Client & de l'Acheteur",
    text: "Grâce aux audits comportementaux, aux modèles de part de portefeuille et à la cartographie des frictions du parcours, nous découvrons ce qui motive vraiment la conversion et la fidélité.",
  },
  {
    title: "Étalonnage des Concurrents",
    text: "Au-delà du benchmarking, nous étudions les bassins de profit des concurrents, les pivots stratégiques et les lacunes de capacité pour découvrir les poches de demande non servies.",
  },
  {
    title: "Validation de Pénétration de Marché",
    text: "Chaque idée est évaluée sur la viabilité financière, la préparation opérationnelle, l'appétit du marché et l'exposition aux risques.",
  },
];

export const businessConsultingHeading = {
  subtitle: "NOS CAPACITÉS DE CONSEIL",
  title: "SOLUTIONS CONÇUES POUR DES ENTREPRISES PLUS INTELLIGENTES",
  description:
    "Chaque mission est conçue pour diagnostiquer les causes profondes et permettre aux dirigeants de renforcer la performance et d'accélérer la croissance avec confiance.",
};

export const businessConsultingData = [
  {
    title: "Réingénierie des Processus Métier",
    text: "Nous identifions les inefficacités cachées dans les opérations quotidiennes et reconstruisons les processus pour la vitesse, l'exactitude et la rentabilité.",
  },
  {
    title: "Amélioration de la Performance Financière",
    text: "Grâce à l'analyse des marges et aux cadres de maîtrise des coûts, nous aidons les entreprises à booster la rentabilité sans perturbations.",
  },
  {
    title: "Structuration Organisationnelle & Gouvernance",
    text: "Nous concevons des structures, des hiérarchies décisionnelles et des modèles de gouvernance qui soutiennent une croissance durable et sans conflit.",
  },
  {
    title: "Stratégie Opérationnelle & Feuilles de Route d'Efficacité",
    text: "Nos consultants construisent des stratégies opérationnelles prêtes pour l'avenir qui rationalisent les flux de travail et réduisent la redondance.",
  },
];

// SERVICES AUX ENTREPRISES
export const entitySetupHeading = {
  subtitle: "NOS SOLUTIONS DE CONSTITUTION",
  title: "ÉTABLISSEZ VOTRE ENTREPRISE SANS RETARDS",
  description:
    "Du choix de la bonne juridiction à l'obtention des licences et à la rédaction des documents d'entreprise, nous simplifions tout le parcours de mise en place avec précision.",
};

export const entitySetupData = [
  {
    title: "Conseil en Juridiction & Structure",
    text: "Nous évaluons vos objectifs et recommandons le type d'entité le plus approprié — SARL, succursale, bureau de représentation, etc.",
  },
  {
    title: "Documentation & Conformité Réglementaire",
    text: "Tous les documents juridiques, dépôts et soumissions gouvernementales sont gérés par nos experts pour garantir une approbation fluide et sans erreur.",
  },
  {
    title: "Gestion des Licences & Enregistrements",
    text: "Nous coordonnons avec les autorités pour obtenir les licences commerciales, les approbations professionnelles et les permis opérationnels.",
  },
  {
    title: "Support Post-Constitution",
    text: "Au-delà de l'enregistrement, nous assistons pour l'ouverture bancaire, l'intégration de la conformité et les essentiels de gouvernance.",
  },
];

export const outsourcedFinanceRegulatoryComplianceHeading = {
  subtitle: "EXPERTISE DE BOUT EN BOUT",
  title: "OPÉRATIONS FINANCIÈRES GÉRÉES SANS AUCUN ÉCART",
  description:
    "Ce qu'apporte notre expertise ? Des processus structurés, des flux de travail automatisés et une supervision axée sur le domaine pour renforcer votre exactitude financière.",
};

export const outsourcedFinanceRegulatoryComplianceData = [
  {
    title: "Gestion Financière en Temps Réel",
    text: "Tenue de livres quotidienne, comptes fournisseurs, comptes clients et clôtures de fin de mois livrées avec précision.",
  },
  {
    title: "Dépôt Réglementaire & Reporting",
    text: "Nous gérons les soumissions fiscales, les déclarations de conformité, les renouvellements de licences, le support ESR et le reporting spécifique à l'industrie.",
  },
  {
    title: "Mise en Place des Contrôles Internes & de la Gouvernance",
    text: "Nous concevons les flux d'approbation, les protocoles documentaires et les structures de gouvernance financière qui vous placent dans une zone sans risque.",
  },
  {
    title: "Surveillance de la Conformité & Alertes de Risque",
    text: "Audits continus, listes de contrôle de conformité et alertes précoces garantissent que vous restez pleinement aligné sur chaque exigence réglementaire.",
  },
];

export const companySecretarialHeading = {
  subtitle: "NOS SOLUTIONS DE GOUVERNANCE",
  title: "UN SUPPORT SECRÉTARIAT QUI FONCTIONNE PARFAITEMENT",
  description:
    "Une entreprise ne reste pas conforme par accident ; elle reste conforme grâce à la discipline, la structure et un partenaire qui suit chaque détail avant qu'il ne devienne un problème.",
};

export const companySecretarialData = [
  {
    title: "Registres Statutaires",
    text: "Nous tenons à jour chaque registre, enregistrons chaque changement et effectuons des audits internes afin que vos livres d'entreprise restent prêts pour l'inspection.",
  },
  {
    title: "Support aux Assemblées d'Actionnaires",
    text: "Une gouvernance fluide commence par des réunions bien gérées. Nous préparons les ordres du jour qui rédigent les avis et résolutions avec une exactitude juridique.",
  },
  {
    title: "Dépôts Réglementaires & Renouvellements",
    text: "Chaque déclaration annuelle, mise à jour réglementaire, renouvellement de licence commerciale, etc., est suivi, préparé et déposé avant l'échéance.",
  },
  {
    title: "Changements Corporatifs & Restructuration",
    text: "Nous gérons les nominations d'administrateurs, les transferts d'actions et les modifications corporatives avec une documentation précise.",
  },
];